<template>
  <div class="row">
    <div class="col-md-12">
      <!-- <div class="pull-left">
        <router-link to="/marketing/promos" class="btn btn-orange"><i class="ti-arrow-left"></i> {{$t('general.back')}}</router-link>
      </div>
      <div class="pull-right">
        <div class="btn btn-icon mar-rt-40 btn-success" :title="$t('reports.export')">
          <i class="ti-file" @click="downloadPoints"></i>
        </div>
      </div> -->
      <!--      <div class="pull-right ">
        <a @click.prevent="handleDelete()" title="Delete" class="btn btn-danger"><i class="ti-trash"></i> Delete</a>
      </div> -->
      <p  class="clearfix"></p>

      <promos-form :route="route" @on-submit="onOfferSubmit" ref="promos"></promos-form>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import {Select, Option} from 'element-ui'
  import PromosForm from './PromosForm.vue'
  // import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'
  Vue.use(Select)
  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
      PromosForm
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        offerModel: {},
        modelValidations: {
          required: {
            required: true
          }
        }
      }
    },
    methods: {
      onOfferSubmit (model, isValid) {
        this.offerModel = model
      },
      downloadPoints () {
        this.$refs.promos.downloadPoints()
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Marketing/Promos/PromosEdit.vue